import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaDraftingCompass, FaCity, FaHome, FaTools, FaRegBuilding } from 'react-icons/fa';
import { BASE_URL } from '../Utils/Function';

const Service = () => {
    const [services, setServices] = useState([]);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleBookNow = (serviceName, serviceImage) => {
        const user = localStorage.getItem('user');
        if (!user) {
            // Redirect to login but remember where we wanted to go
            navigate('/login', {
                state: {
                    redirectTo: '/booking',
                    bookingState: { serviceName, serviceImage }
                }
            });
            return;
        }
        navigate('/booking', { state: { serviceName, serviceImage } });
    };

    useEffect(() => {
        axios.get(`${BASE_URL}/service/getAllService.php`)
            .then(res => {
                const data = res.data;
                if (Array.isArray(data)) {
                    setServices(data);
                } else if (data && Array.isArray(data.data)) {
                    setServices(data.data);
                } else {
                    console.error("API did not return an array:", data);
                    setServices([]);
                }
            })
            .catch(err => {
                console.error("Error fetching services:", err);
                const status = err.response ? err.response.status : 'Network';
                const message = err.response?.data?.message || err.message;
                setError(`Failed to load services (${status}: ${message})`);
                setServices([]);
            });
    }, []);

    // Icon mapping helper (for fallback if no image)
    const getServiceIcon = (title) => {
        const lowerTitle = (title || "").toLowerCase();
        if (lowerTitle.includes('design')) return <FaDraftingCompass />;
        if (lowerTitle.includes('planning')) return <FaCity />;
        if (lowerTitle.includes('construction') || lowerTitle.includes('building')) return <FaHome />;
        if (lowerTitle.includes('consultation')) return <FaTools />;
        return <FaRegBuilding />; // Default icon
    };

    return (
        <div id="service" className="architectural-bg" style={{ padding: 'var(--section-padding)' }}>
            <div className="container">
                <div className="row mb-5">
                    <div className="col-lg-12">
                        <h2 className="section-head-main">Our Services</h2>
                    </div>
                </div>

                <div className="row g-4">
                    {services.map((svc, index) => (
                        <div key={index} className="col-6 col-md-4 col-lg-3">
                            <div className="arch-card h-100 p-2 p-md-4 text-center d-flex flex-column align-items-center">
                                <div className="mb-4">
                                    {svc.image_url ? (
                                        <div
                                            className="overflow-hidden"
                                            style={{
                                                width: 'clamp(40px, 15vw, 80px)',
                                                height: 'clamp(40px, 15vw, 80px)'
                                            }}
                                        >
                                            <img
                                                src={svc.image_url.startsWith('http') ? svc.image_url : `${BASE_URL}/${svc.image_url}`}
                                                alt={svc.serv_name}
                                                className="w-100 h-100"
                                                style={{ objectFit: 'contain' }}
                                            />
                                        </div>
                                    ) : (
                                        <div style={{ color: 'var(--secondary-color)', fontSize: 'clamp(1.5rem, 8vw, 2.5rem)' }}>
                                            {getServiceIcon(svc.serv_name)}
                                        </div>
                                    )}
                                </div>

                                <div className="w-100 flex-grow-1 d-flex flex-column align-items-center">
                                    <h4 className="mb-3 mb-md-4" style={{ fontWeight: '400', letterSpacing: '-0.5px', fontSize: 'clamp(0.8rem, 2.5vw, 1rem)' }}>{svc.serv_name}</h4>
                                    <div className="mt-auto ms-auto">
                                        <button
                                            className="btn-book-now"
                                            style={{ padding: '6px 12px', fontSize: '0.55rem' }}
                                            onClick={() => handleBookNow(svc.serv_name, svc.image_url)}
                                        >
                                            Book Now
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}

                    {services.length === 0 && !error && (
                        <div className="col-12 text-center">
                            <p style={{ color: 'var(--text-secondary)' }}>Loading our world-class services...</p>
                        </div>
                    )}

                    {error && (
                        <div className="col-12 text-center">
                            <p className="text-danger small">{error}</p>
                            <p className="text-secondary small mt-2">Please ensure your backend is running at {BASE_URL}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};


export default Service;


